// source: itrdrinstrument.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var fix_pb = require('./fix_pb.js');
goog.object.extend(proto, fix_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var itrdrmsgs_common_pb = require('./itrdrmsgs_common_pb.js');
goog.object.extend(proto, itrdrmsgs_common_pb);
goog.exportSymbol('proto.it_grpc.ITrdrCompoundInstrument', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrCompoundInstrumentLegInfo', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrExchangeInstrument', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrExchangeInstrument.ExtInfoCase', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrFuturesInstrumentInfo', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrument', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrument.ExtInfoCase', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentSummary', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentSummaryFields', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrUSTInstrumentInfo', null, global);
goog.exportSymbol('proto.it_grpc.InstrumentAdditionalInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.InstrumentAdditionalInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.InstrumentAdditionalInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.InstrumentAdditionalInfo.displayName = 'proto.it_grpc.InstrumentAdditionalInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentSummaryFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentSummaryFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentSummaryFields.displayName = 'proto.it_grpc.ITrdrInstrumentSummaryFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrInstrumentSummary.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentSummary.displayName = 'proto.it_grpc.ITrdrInstrumentSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrUSTInstrumentInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrUSTInstrumentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrUSTInstrumentInfo.displayName = 'proto.it_grpc.ITrdrUSTInstrumentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrFuturesInstrumentInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrFuturesInstrumentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrFuturesInstrumentInfo.displayName = 'proto.it_grpc.ITrdrFuturesInstrumentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrCompoundInstrumentLegInfo.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrCompoundInstrumentLegInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrCompoundInstrumentLegInfo.displayName = 'proto.it_grpc.ITrdrCompoundInstrumentLegInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrCompoundInstrument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrCompoundInstrument.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrCompoundInstrument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrCompoundInstrument.displayName = 'proto.it_grpc.ITrdrCompoundInstrument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrExchangeInstrument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.it_grpc.ITrdrExchangeInstrument.oneofGroups_);
};
goog.inherits(proto.it_grpc.ITrdrExchangeInstrument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrExchangeInstrument.displayName = 'proto.it_grpc.ITrdrExchangeInstrument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.it_grpc.ITrdrInstrument.oneofGroups_);
};
goog.inherits(proto.it_grpc.ITrdrInstrument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrument.displayName = 'proto.it_grpc.ITrdrInstrument';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.InstrumentAdditionalInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.InstrumentAdditionalInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.InstrumentAdditionalInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    broadwayTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bbgSymbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    yellowKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    exchangeSymbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    notional: (f = msg.getNotional()) && fix_pb.Decimal64.toObject(includeInstance, f),
    yearFraction: (f = msg.getYearFraction()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.InstrumentAdditionalInfo}
 */
proto.it_grpc.InstrumentAdditionalInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.InstrumentAdditionalInfo;
  return proto.it_grpc.InstrumentAdditionalInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.InstrumentAdditionalInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.InstrumentAdditionalInfo}
 */
proto.it_grpc.InstrumentAdditionalInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroadwayTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBbgSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setYellowKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeSymbol(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setNotional(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setYearFraction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.InstrumentAdditionalInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.InstrumentAdditionalInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.InstrumentAdditionalInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBroadwayTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBbgSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getYellowKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExchangeSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNotional();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getYearFraction();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional string broadway_ticker = 1;
 * @return {string}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.getBroadwayTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentAdditionalInfo} returns this
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.setBroadwayTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bbg_symbol = 2;
 * @return {string}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.getBbgSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentAdditionalInfo} returns this
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.setBbgSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string yellow_key = 3;
 * @return {string}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.getYellowKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentAdditionalInfo} returns this
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.setYellowKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string exchange_symbol = 4;
 * @return {string}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.getExchangeSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentAdditionalInfo} returns this
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.setExchangeSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional fix.Decimal64 notional = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.getNotional = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.InstrumentAdditionalInfo} returns this
*/
proto.it_grpc.InstrumentAdditionalInfo.prototype.setNotional = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.InstrumentAdditionalInfo} returns this
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.clearNotional = function() {
  return this.setNotional(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.hasNotional = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Decimal64 year_fraction = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.getYearFraction = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.InstrumentAdditionalInfo} returns this
*/
proto.it_grpc.InstrumentAdditionalInfo.prototype.setYearFraction = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.InstrumentAdditionalInfo} returns this
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.clearYearFraction = function() {
  return this.setYearFraction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.InstrumentAdditionalInfo.prototype.hasYearFraction = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentSummaryFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentSummaryFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    securityDescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    bbgSymbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    yellowKey: jspb.Message.getFieldWithDefault(msg, 6, ""),
    exchangeSymbol: jspb.Message.getFieldWithDefault(msg, 7, ""),
    instrumentSource: jspb.Message.getFieldWithDefault(msg, 8, ""),
    notional: (f = msg.getNotional()) && fix_pb.Decimal64.toObject(includeInstance, f),
    yearFraction: (f = msg.getYearFraction()) && fix_pb.Decimal64.toObject(includeInstance, f),
    instrumentType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    instrumentSubType: jspb.Message.getFieldWithDefault(msg, 12, 0),
    maturityDate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    isExpired: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    changeUserid: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentSummaryFields;
  return proto.it_grpc.ITrdrInstrumentSummaryFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentSummaryFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBbgSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setYellowKey(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeSymbol(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrumentSource(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setNotional(value);
      break;
    case 10:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setYearFraction(value);
      break;
    case 11:
      var value = /** @type {!proto.it_grpc.ItrdrInstrumentTypeEnum} */ (reader.readEnum());
      msg.setInstrumentType(value);
      break;
    case 12:
      var value = /** @type {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} */ (reader.readEnum());
      msg.setInstrumentSubType(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setMaturityDate(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsExpired(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangeUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentSummaryFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentSummaryFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSecurityDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBbgSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getYellowKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExchangeSymbol();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getInstrumentSource();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNotional();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getYearFraction();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getInstrumentSubType();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getMaturityDate();
  if (f !== 0) {
    writer.writeSfixed32(
      13,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getIsExpired();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getChangeUserid();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string security_id = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string security_description = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getSecurityDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setSecurityDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string display_name = 4;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string bbg_symbol = 5;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getBbgSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setBbgSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string yellow_key = 6;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getYellowKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setYellowKey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string exchange_symbol = 7;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getExchangeSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setExchangeSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string instrument_source = 8;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getInstrumentSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setInstrumentSource = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional fix.Decimal64 notional = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getNotional = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
*/
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setNotional = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.clearNotional = function() {
  return this.setNotional(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.hasNotional = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional fix.Decimal64 year_fraction = 10;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getYearFraction = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 10));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
*/
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setYearFraction = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.clearYearFraction = function() {
  return this.setYearFraction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.hasYearFraction = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional ItrdrInstrumentTypeEnum instrument_type = 11;
 * @return {!proto.it_grpc.ItrdrInstrumentTypeEnum}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getInstrumentType = function() {
  return /** @type {!proto.it_grpc.ItrdrInstrumentTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.it_grpc.ItrdrInstrumentTypeEnum} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setInstrumentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional ItrdrInstrumentSubTypeEnum instrument_sub_type = 12;
 * @return {!proto.it_grpc.ItrdrInstrumentSubTypeEnum}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getInstrumentSubType = function() {
  return /** @type {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setInstrumentSubType = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional sfixed32 maturity_date = 13;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getMaturityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setMaturityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional bool is_active = 14;
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool is_expired = 15;
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getIsExpired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setIsExpired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string change_userid = 16;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.getChangeUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentSummaryFields.prototype.setChangeUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrInstrumentSummary.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    instSummaryList: jspb.Message.toObjectList(msg.getInstSummaryList(),
    proto.it_grpc.ITrdrInstrumentSummaryFields.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentSummary}
 */
proto.it_grpc.ITrdrInstrumentSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentSummary;
  return proto.it_grpc.ITrdrInstrumentSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentSummary}
 */
proto.it_grpc.ITrdrInstrumentSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrInstrumentSummaryFields;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentSummaryFields.deserializeBinaryFromReader);
      msg.addInstSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstSummaryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrInstrumentSummaryFields.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrInstrumentSummaryFields inst_summary = 1;
 * @return {!Array<!proto.it_grpc.ITrdrInstrumentSummaryFields>}
 */
proto.it_grpc.ITrdrInstrumentSummary.prototype.getInstSummaryList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrInstrumentSummaryFields>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrInstrumentSummaryFields, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrInstrumentSummaryFields>} value
 * @return {!proto.it_grpc.ITrdrInstrumentSummary} returns this
*/
proto.it_grpc.ITrdrInstrumentSummary.prototype.setInstSummaryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrInstrumentSummaryFields=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrInstrumentSummaryFields}
 */
proto.it_grpc.ITrdrInstrumentSummary.prototype.addInstSummary = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrInstrumentSummaryFields, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrInstrumentSummary} returns this
 */
proto.it_grpc.ITrdrInstrumentSummary.prototype.clearInstSummaryList = function() {
  return this.setInstSummaryList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrUSTInstrumentInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrUSTInstrumentInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrUSTInstrumentInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUSTInstrumentInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrUSTInstrumentInfo}
 */
proto.it_grpc.ITrdrUSTInstrumentInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrUSTInstrumentInfo;
  return proto.it_grpc.ITrdrUSTInstrumentInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrUSTInstrumentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrUSTInstrumentInfo}
 */
proto.it_grpc.ITrdrUSTInstrumentInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrUSTInstrumentInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrUSTInstrumentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrUSTInstrumentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUSTInstrumentInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrFuturesInstrumentInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrFuturesInstrumentInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrFuturesInstrumentInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrFuturesInstrumentInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrFuturesInstrumentInfo}
 */
proto.it_grpc.ITrdrFuturesInstrumentInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrFuturesInstrumentInfo;
  return proto.it_grpc.ITrdrFuturesInstrumentInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrFuturesInstrumentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrFuturesInstrumentInfo}
 */
proto.it_grpc.ITrdrFuturesInstrumentInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrFuturesInstrumentInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrFuturesInstrumentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrFuturesInstrumentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrFuturesInstrumentInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrCompoundInstrumentLegInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    legIndex: jspb.Message.getFieldWithDefault(msg, 1, 0),
    securityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    instSummary: (f = msg.getInstSummary()) && proto.it_grpc.ITrdrInstrumentSummaryFields.toObject(includeInstance, f),
    legStipulations: jspb.Message.getFieldWithDefault(msg, 4, ""),
    legMessagesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrCompoundInstrumentLegInfo;
  return proto.it_grpc.ITrdrCompoundInstrumentLegInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegIndex(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 3:
      var value = new proto.it_grpc.ITrdrInstrumentSummaryFields;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentSummaryFields.deserializeBinaryFromReader);
      msg.setInstSummary(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegStipulations(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addLegMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrCompoundInstrumentLegInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegIndex();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInstSummary();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.it_grpc.ITrdrInstrumentSummaryFields.serializeBinaryToWriter
    );
  }
  f = message.getLegStipulations();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLegMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional int32 leg_index = 1;
 * @return {number}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.getLegIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} returns this
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.setLegIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string security_id = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} returns this
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ITrdrInstrumentSummaryFields inst_summary = 3;
 * @return {?proto.it_grpc.ITrdrInstrumentSummaryFields}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.getInstSummary = function() {
  return /** @type{?proto.it_grpc.ITrdrInstrumentSummaryFields} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrInstrumentSummaryFields, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrInstrumentSummaryFields|undefined} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} returns this
*/
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.setInstSummary = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} returns this
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.clearInstSummary = function() {
  return this.setInstSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.hasInstSummary = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string leg_stipulations = 4;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.getLegStipulations = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} returns this
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.setLegStipulations = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string leg_messages = 5;
 * @return {!Array<string>}
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.getLegMessagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} returns this
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.setLegMessagesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} returns this
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.addLegMessages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo} returns this
 */
proto.it_grpc.ITrdrCompoundInstrumentLegInfo.prototype.clearLegMessagesList = function() {
  return this.setLegMessagesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrCompoundInstrument.repeatedFields_ = [7,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrCompoundInstrument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrCompoundInstrument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrCompoundInstrument.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityDescription: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pricingName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    instSource: jspb.Message.getFieldWithDefault(msg, 4, ""),
    exchange: jspb.Message.getFieldWithDefault(msg, 5, ""),
    stipulations: jspb.Message.getFieldWithDefault(msg, 6, ""),
    legInfoList: jspb.Message.toObjectList(msg.getLegInfoList(),
    proto.it_grpc.ITrdrCompoundInstrumentLegInfo.toObject, includeInstance),
    lastUpdUser: jspb.Message.getFieldWithDefault(msg, 8, ""),
    lastUpdTimestamp: (f = msg.getLastUpdTimestamp()) && fix_pb.Timestamp.toObject(includeInstance, f),
    spreadMessagesList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    changeUserid: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrCompoundInstrument}
 */
proto.it_grpc.ITrdrCompoundInstrument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrCompoundInstrument;
  return proto.it_grpc.ITrdrCompoundInstrument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrCompoundInstrument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrCompoundInstrument}
 */
proto.it_grpc.ITrdrCompoundInstrument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPricingName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstSource(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchange(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStipulations(value);
      break;
    case 7:
      var value = new proto.it_grpc.ITrdrCompoundInstrumentLegInfo;
      reader.readMessage(value,proto.it_grpc.ITrdrCompoundInstrumentLegInfo.deserializeBinaryFromReader);
      msg.addLegInfo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastUpdUser(value);
      break;
    case 9:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdTimestamp(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addSpreadMessages(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangeUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrCompoundInstrument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrCompoundInstrument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrCompoundInstrument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecurityDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPricingName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInstSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExchange();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStipulations();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLegInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.it_grpc.ITrdrCompoundInstrumentLegInfo.serializeBinaryToWriter
    );
  }
  f = message.getLastUpdUser();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLastUpdTimestamp();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSpreadMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getChangeUserid();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string security_id = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string security_description = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getSecurityDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setSecurityDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string pricing_name = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getPricingName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setPricingName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string inst_source = 4;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getInstSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setInstSource = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string exchange = 5;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string stipulations = 6;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getStipulations = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setStipulations = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated ITrdrCompoundInstrumentLegInfo leg_info = 7;
 * @return {!Array<!proto.it_grpc.ITrdrCompoundInstrumentLegInfo>}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getLegInfoList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrCompoundInstrumentLegInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrCompoundInstrumentLegInfo, 7));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrCompoundInstrumentLegInfo>} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
*/
proto.it_grpc.ITrdrCompoundInstrument.prototype.setLegInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrCompoundInstrumentLegInfo}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.addLegInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.it_grpc.ITrdrCompoundInstrumentLegInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.clearLegInfoList = function() {
  return this.setLegInfoList([]);
};


/**
 * optional string last_upd_user = 8;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getLastUpdUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setLastUpdUser = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional fix.Timestamp last_upd_timestamp = 9;
 * @return {?proto.fix.Timestamp}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getLastUpdTimestamp = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 9));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
*/
proto.it_grpc.ITrdrCompoundInstrument.prototype.setLastUpdTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.clearLastUpdTimestamp = function() {
  return this.setLastUpdTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.hasLastUpdTimestamp = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated string spread_messages = 10;
 * @return {!Array<string>}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getSpreadMessagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setSpreadMessagesList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.addSpreadMessages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.clearSpreadMessagesList = function() {
  return this.setSpreadMessagesList([]);
};


/**
 * optional string change_userid = 11;
 * @return {string}
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.getChangeUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCompoundInstrument} returns this
 */
proto.it_grpc.ITrdrCompoundInstrument.prototype.setChangeUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.it_grpc.ITrdrExchangeInstrument.oneofGroups_ = [[5,6]];

/**
 * @enum {number}
 */
proto.it_grpc.ITrdrExchangeInstrument.ExtInfoCase = {
  EXT_INFO_NOT_SET: 0,
  UST_EXTENDED_INFO: 5,
  FUT_EXTENDED_INFO: 6
};

/**
 * @return {proto.it_grpc.ITrdrExchangeInstrument.ExtInfoCase}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.getExtInfoCase = function() {
  return /** @type {proto.it_grpc.ITrdrExchangeInstrument.ExtInfoCase} */(jspb.Message.computeOneofCase(this, proto.it_grpc.ITrdrExchangeInstrument.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrExchangeInstrument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrExchangeInstrument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExchangeInstrument.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityDescription: jspb.Message.getFieldWithDefault(msg, 2, ""),
    instrumentSubType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    ustExtendedInfo: (f = msg.getUstExtendedInfo()) && proto.it_grpc.ITrdrUSTInstrumentInfo.toObject(includeInstance, f),
    futExtendedInfo: (f = msg.getFutExtendedInfo()) && proto.it_grpc.ITrdrFuturesInstrumentInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrExchangeInstrument}
 */
proto.it_grpc.ITrdrExchangeInstrument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrExchangeInstrument;
  return proto.it_grpc.ITrdrExchangeInstrument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrExchangeInstrument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrExchangeInstrument}
 */
proto.it_grpc.ITrdrExchangeInstrument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityDescription(value);
      break;
    case 3:
      var value = /** @type {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} */ (reader.readEnum());
      msg.setInstrumentSubType(value);
      break;
    case 4:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 5:
      var value = new proto.it_grpc.ITrdrUSTInstrumentInfo;
      reader.readMessage(value,proto.it_grpc.ITrdrUSTInstrumentInfo.deserializeBinaryFromReader);
      msg.setUstExtendedInfo(value);
      break;
    case 6:
      var value = new proto.it_grpc.ITrdrFuturesInstrumentInfo;
      reader.readMessage(value,proto.it_grpc.ITrdrFuturesInstrumentInfo.deserializeBinaryFromReader);
      msg.setFutExtendedInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrExchangeInstrument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrExchangeInstrument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExchangeInstrument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecurityDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInstrumentSubType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getUstExtendedInfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.it_grpc.ITrdrUSTInstrumentInfo.serializeBinaryToWriter
    );
  }
  f = message.getFutExtendedInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.it_grpc.ITrdrFuturesInstrumentInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string security_id = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string security_description = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.getSecurityDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.setSecurityDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ItrdrInstrumentSubTypeEnum instrument_sub_type = 3;
 * @return {!proto.it_grpc.ItrdrInstrumentSubTypeEnum}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.getInstrumentSubType = function() {
  return /** @type {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} value
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.setInstrumentSubType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Common.Instrument instrument = 4;
 * @return {?proto.Common.Instrument}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 4));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
*/
proto.it_grpc.ITrdrExchangeInstrument.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ITrdrUSTInstrumentInfo ust_extended_info = 5;
 * @return {?proto.it_grpc.ITrdrUSTInstrumentInfo}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.getUstExtendedInfo = function() {
  return /** @type{?proto.it_grpc.ITrdrUSTInstrumentInfo} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrUSTInstrumentInfo, 5));
};


/**
 * @param {?proto.it_grpc.ITrdrUSTInstrumentInfo|undefined} value
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
*/
proto.it_grpc.ITrdrExchangeInstrument.prototype.setUstExtendedInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.it_grpc.ITrdrExchangeInstrument.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.clearUstExtendedInfo = function() {
  return this.setUstExtendedInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.hasUstExtendedInfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ITrdrFuturesInstrumentInfo fut_extended_info = 6;
 * @return {?proto.it_grpc.ITrdrFuturesInstrumentInfo}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.getFutExtendedInfo = function() {
  return /** @type{?proto.it_grpc.ITrdrFuturesInstrumentInfo} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrFuturesInstrumentInfo, 6));
};


/**
 * @param {?proto.it_grpc.ITrdrFuturesInstrumentInfo|undefined} value
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
*/
proto.it_grpc.ITrdrExchangeInstrument.prototype.setFutExtendedInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.it_grpc.ITrdrExchangeInstrument.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrExchangeInstrument} returns this
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.clearFutExtendedInfo = function() {
  return this.setFutExtendedInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrExchangeInstrument.prototype.hasFutExtendedInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.it_grpc.ITrdrInstrument.oneofGroups_ = [[9,10]];

/**
 * @enum {number}
 */
proto.it_grpc.ITrdrInstrument.ExtInfoCase = {
  EXT_INFO_NOT_SET: 0,
  EXCHANGE_INSTRUMENT_INFO: 9,
  COMPOUND_INSTRUMENT_INFO: 10
};

/**
 * @return {proto.it_grpc.ITrdrInstrument.ExtInfoCase}
 */
proto.it_grpc.ITrdrInstrument.prototype.getExtInfoCase = function() {
  return /** @type {proto.it_grpc.ITrdrInstrument.ExtInfoCase} */(jspb.Message.computeOneofCase(this, proto.it_grpc.ITrdrInstrument.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrument.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrument.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: (f = msg.getUuid()) && itrdrmsgs_common_pb.ITrdrUUID.toObject(includeInstance, f),
    securityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    securityDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    instrumentType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    instrumentSubType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    addlInfo: (f = msg.getAddlInfo()) && proto.it_grpc.InstrumentAdditionalInfo.toObject(includeInstance, f),
    exchangeInstrumentInfo: (f = msg.getExchangeInstrumentInfo()) && proto.it_grpc.ITrdrExchangeInstrument.toObject(includeInstance, f),
    compoundInstrumentInfo: (f = msg.getCompoundInstrumentInfo()) && proto.it_grpc.ITrdrCompoundInstrument.toObject(includeInstance, f),
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    isExpired: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    hasErrors: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrument}
 */
proto.it_grpc.ITrdrInstrument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrument;
  return proto.it_grpc.ITrdrInstrument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrument}
 */
proto.it_grpc.ITrdrInstrument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrUUID;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrUUID.deserializeBinaryFromReader);
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 6:
      var value = /** @type {!proto.it_grpc.ItrdrInstrumentTypeEnum} */ (reader.readEnum());
      msg.setInstrumentType(value);
      break;
    case 7:
      var value = /** @type {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} */ (reader.readEnum());
      msg.setInstrumentSubType(value);
      break;
    case 8:
      var value = new proto.it_grpc.InstrumentAdditionalInfo;
      reader.readMessage(value,proto.it_grpc.InstrumentAdditionalInfo.deserializeBinaryFromReader);
      msg.setAddlInfo(value);
      break;
    case 9:
      var value = new proto.it_grpc.ITrdrExchangeInstrument;
      reader.readMessage(value,proto.it_grpc.ITrdrExchangeInstrument.deserializeBinaryFromReader);
      msg.setExchangeInstrumentInfo(value);
      break;
    case 10:
      var value = new proto.it_grpc.ITrdrCompoundInstrument;
      reader.readMessage(value,proto.it_grpc.ITrdrCompoundInstrument.deserializeBinaryFromReader);
      msg.setCompoundInstrumentInfo(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsExpired(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrUUID.serializeBinaryToWriter
    );
  }
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSecurityDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInstrumentType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getInstrumentSubType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getAddlInfo();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.it_grpc.InstrumentAdditionalInfo.serializeBinaryToWriter
    );
  }
  f = message.getExchangeInstrumentInfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.it_grpc.ITrdrExchangeInstrument.serializeBinaryToWriter
    );
  }
  f = message.getCompoundInstrumentInfo();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.it_grpc.ITrdrCompoundInstrument.serializeBinaryToWriter
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsExpired();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getHasErrors();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional ITrdrUUID uuid = 1;
 * @return {?proto.it_grpc.ITrdrUUID}
 */
proto.it_grpc.ITrdrInstrument.prototype.getUuid = function() {
  return /** @type{?proto.it_grpc.ITrdrUUID} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrUUID, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrUUID|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
*/
proto.it_grpc.ITrdrInstrument.prototype.setUuid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.clearUuid = function() {
  return this.setUuid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrument.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string security_id = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrument.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrument.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string security_description = 4;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrument.prototype.getSecurityDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setSecurityDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_name = 5;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrument.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ItrdrInstrumentTypeEnum instrument_type = 6;
 * @return {!proto.it_grpc.ItrdrInstrumentTypeEnum}
 */
proto.it_grpc.ITrdrInstrument.prototype.getInstrumentType = function() {
  return /** @type {!proto.it_grpc.ItrdrInstrumentTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.it_grpc.ItrdrInstrumentTypeEnum} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setInstrumentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional ItrdrInstrumentSubTypeEnum instrument_sub_type = 7;
 * @return {!proto.it_grpc.ItrdrInstrumentSubTypeEnum}
 */
proto.it_grpc.ITrdrInstrument.prototype.getInstrumentSubType = function() {
  return /** @type {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setInstrumentSubType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional InstrumentAdditionalInfo addl_info = 8;
 * @return {?proto.it_grpc.InstrumentAdditionalInfo}
 */
proto.it_grpc.ITrdrInstrument.prototype.getAddlInfo = function() {
  return /** @type{?proto.it_grpc.InstrumentAdditionalInfo} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.InstrumentAdditionalInfo, 8));
};


/**
 * @param {?proto.it_grpc.InstrumentAdditionalInfo|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
*/
proto.it_grpc.ITrdrInstrument.prototype.setAddlInfo = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.clearAddlInfo = function() {
  return this.setAddlInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrument.prototype.hasAddlInfo = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ITrdrExchangeInstrument exchange_instrument_info = 9;
 * @return {?proto.it_grpc.ITrdrExchangeInstrument}
 */
proto.it_grpc.ITrdrInstrument.prototype.getExchangeInstrumentInfo = function() {
  return /** @type{?proto.it_grpc.ITrdrExchangeInstrument} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrExchangeInstrument, 9));
};


/**
 * @param {?proto.it_grpc.ITrdrExchangeInstrument|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
*/
proto.it_grpc.ITrdrInstrument.prototype.setExchangeInstrumentInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.it_grpc.ITrdrInstrument.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.clearExchangeInstrumentInfo = function() {
  return this.setExchangeInstrumentInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrument.prototype.hasExchangeInstrumentInfo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ITrdrCompoundInstrument compound_instrument_info = 10;
 * @return {?proto.it_grpc.ITrdrCompoundInstrument}
 */
proto.it_grpc.ITrdrInstrument.prototype.getCompoundInstrumentInfo = function() {
  return /** @type{?proto.it_grpc.ITrdrCompoundInstrument} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrCompoundInstrument, 10));
};


/**
 * @param {?proto.it_grpc.ITrdrCompoundInstrument|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
*/
proto.it_grpc.ITrdrInstrument.prototype.setCompoundInstrumentInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.it_grpc.ITrdrInstrument.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.clearCompoundInstrumentInfo = function() {
  return this.setCompoundInstrumentInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrument.prototype.hasCompoundInstrumentInfo = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool is_active = 11;
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrument.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool is_expired = 12;
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrument.prototype.getIsExpired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setIsExpired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool has_errors = 13;
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrument.prototype.getHasErrors = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrInstrument} returns this
 */
proto.it_grpc.ITrdrInstrument.prototype.setHasErrors = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


goog.object.extend(exports, proto.it_grpc);
